<template>
  <div class="travel-report">
    <p>出差报告</p>
    <div class="p10">

      <el-date-picker
          v-model="time"
          size="mini"
          type="daterange"
          value-format="yyyy-MM-dd hh:mm:ss"
          range-separator="-"
          @change="getPlatformSaleTravelReportList"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
      </el-date-picker>
    </div>
    <el-table :data="report_list" style="width: 100%">
      <el-table-column label="添加时间" align="center" width="120">
        <template slot-scope="scope">{{ formatDate(scope.row.create_time, 'yyyy-MM-dd') }}</template>
      </el-table-column>
      <el-table-column
          label="打卡时间"
          width="180"
          prop="clock_in_time"
          align="center"
      >
      </el-table-column>
      <el-table-column
          label="状态"
          prop="clock_in_time"
          align="center"
      >
        <template slot-scope="scope">
          <span class=" red" v-if="is_Empty(scope.row.company_visit_record_id)">未填写</span>
          <span class=" green" v-else>已填写</span>
        </template>
      </el-table-column>
      <!--      <el-table-column prop="topic_name" label="出差主题" align="center" width="120"/>-->
      <!--      <el-table-column prop="transportation_name" label="出差方式" align="center" width="120"/>-->
      <!--      <el-table-column prop="platform_sale_name" label="销售" width="80" align="center"/>-->
      <!--      <el-table-column prop="companyVisitRecordBean.contact_person" label="联系人" width="80" align="center"/>-->
      <el-table-column prop="company_name" label="拜访客户" align="center" width="300"/>
      <!--      <el-table-column prop="companyVisitRecordBean.content" label="联系内容" align="center"/>-->
      <el-table-column prop="companyVisitRecordBean.content" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" v-if="is_Empty(scope.row.company_visit_record_id) &&hasPermission (557)"
                     @click="addReport(scope.row,1)">填写报告
          </el-button>
          <el-button type="text" v-show="!is_Empty(scope.row.company_visit_record_id) && hasPermission(558)"
                     @click="addReport(scope.row,0)">详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <handle-report v-model="contact_show" :info="info" @success="getPlatformSaleTravelReportList"/>
  </div>
</template>

<script>
import handleReport from "./components/handleReport";

export default {
  name: "index",
  data() {
    return {
      currentDate: new Date(),
      report_list: [],
      contact_show: false,
      info: {},
      time: []
    }
  },
  created() {
    this.time = [`${this.formatTime(this.currentDate)}-01 00:00:00`, `${this.formatDate(this.CurrentMonthLast(this.currentDate), 'yyyy-MM-dd')} 23:59:59`]
    this.getPlatformSaleTravelReportList();
  },
  methods: {
    async addReport(row, type) {

      this.info = row;
      this.contact_show = true;
    },
    formatTime(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1
      }`;
    },
    // 获取每月的最后一天
    CurrentMonthLast(date) {
      let currentMonth = date.getMonth();
      let nextMonth = ++currentMonth;
      let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      let oneDay = 1000 * 60 * 60 * 24;
      return new Date(nextMonthFirstDay - oneDay);
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    getPlatformSaleTravelReportList() {
      if (this.is_Empty(this.time)) return;
      this.show = false;
      let obj = {
        start_time: this.time[0],
        end_time: this.time[1],
      };
      this.post("app/travelReport/getPlatformSaleTravelReportList", obj).then(res => {
        this.report_list = res.data;
      })
    },
  },
  components: {handleReport}
}
</script>

<style scoped lang="scss">
.travel-report {
}
</style>


// WEBPACK FOOTER //
// src/page/me/travelReport/index.vue